export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        id: 2,
        label: 'menuitems.dashboard.text',
        icon: 'ri-dashboard-line',
        badge: {
            variant: "success",
            text: "menuitems.dashboard.badge"
        },
        link: '/'
    },
    {
        id: 1003,
        label: 'menuitems.customers.text',
        icon: 'ri-team-fill',
        link: '/customers'
    },
    {
        id: 1004,
        label: 'menuitems.customerTasks.text',
        icon: 'ri-list-check-2',
        subItems: [
            {
                id: 1008,
                label: 'menuitems.customerTasksSync.text',
                link: '/customer-tasks',
            },
            {
                id: 1009,
                label: 'menuitems.customerTasksRawCommands.text',
                link: '/customer-tasks-raw-command',
            }
        ]
    },
    {
        id: 1005,
        label: 'menuitems.sourceDrivers.text',
        icon: 'ri-download-cloud-2-fill',
        link: '/source-drivers'
    },
    {
        id: 1006,
        label: 'menuitems.targetDrivers.text',
        icon: 'ri-upload-cloud-2-fill',
        link: '/target-drivers'
    },
    {
        id: 1007,
        label: 'menuitems.users.text',
        icon: 'ri-shield-user-fill',
        link: '/users'
    }
]